import api from '../../../lib/api';
import type {
  PaginatedResponse,
  SendMessageInput,
  WhatsAppConversation,
  WhatsAppMessage,
  WhatsAppTemplate,
  WindowStatus,
} from '../types';

export const whatsappApi = {
  getConversations: (params: {
    organizationId: string;
    leadId?: string;
    limit?: number;
    cursor?: string;
  }) =>
    api
      .get<PaginatedResponse<WhatsAppConversation>>('/communications/whatsapp/conversations', {
        params,
      })
      .then((res) => res.data),

  getMessages: (
    conversationId: string,
    organizationId: string,
    params?: { limit?: number; cursor?: string },
  ) =>
    api
      .get<PaginatedResponse<WhatsAppMessage>>(
        `/communications/whatsapp/conversations/${conversationId}/messages`,
        { params: { ...params, organizationId } },
      )
      .then((res) => res.data),

  sendMessage: (conversationId: string, organizationId: string, input: SendMessageInput) =>
    api
      .post<WhatsAppMessage>(`/communications/whatsapp/conversations/${conversationId}/messages`, {
        ...input,
        organizationId,
      })
      .then((res) => res.data),

  markAsRead: (conversationId: string, organizationId: string) =>
    api
      .patch(`/communications/whatsapp/conversations/${conversationId}/read`, null, {
        params: { organizationId },
      })
      .then((res) => res.data),

  getWindowStatus: (conversationId: string, organizationId: string) =>
    api
      .get<WindowStatus>(`/communications/whatsapp/conversations/${conversationId}/window`, {
        params: { organizationId },
      })
      .then((res) => res.data),

  getTemplates: (organizationId: string) =>
    api
      .get<WhatsAppTemplate[]>('/communications/whatsapp/templates', { params: { organizationId } })
      .then((res) => res.data),

  syncTemplates: (organizationId: string) =>
    api
      .post('/communications/whatsapp/templates/sync', null, { params: { organizationId } })
      .then((res) => res.data),
};
